module.exports = __webpack_public_path__ + "img/bs_get.94f03d4.png";